import { NewsState } from 'common/types/entities/news'
import { fetchStoreNewsByNewsParam } from 'common/services/list'
import { NewsParam } from 'common/types/params'
import { ContentType } from 'common/constants'
import history, { HistoryStateKey } from 'common/history'
import { StateKey } from 'common/utils/flipState'

export interface NewsListState {
  newsState: NewsState
  page: number
}

const initialState: NewsListState = {
  newsState: { articles: [], hasMore: false },
  page: 1,
}

const INIT = 'news/newsList/INIT'
const APPEND = 'news/newsList/APPEND'
const RESTORE = 'news/newsList/RESTORE'

export const initNews = (curState: StateKey, param: NewsParam) => async dispatch => {
  const restoredNews = getNewsFromHistoryState()
  if (restoredNews) {
    dispatch({
      curState,
      ...restoredNews,
      type: RESTORE,
    })
    return
  }

  if (param.contentType === ContentType.NONE) {
    param.contentType = null
  }
  const newsState: NewsState = await fetchStoreNewsByNewsParam(param)
  if (newsState) {
    !newsState.contentType && (newsState.contentType = ContentType.NONE)
    dispatch({ curState, newsState, type: INIT, page: param.page })
  }
}

export const appendNews = (curState: StateKey, param: NewsParam) => async dispatch => {
  if (param.contentType === ContentType.NONE) {
    param.contentType = null
  }
  const newsState: NewsState = await fetchStoreNewsByNewsParam(param)
  if (newsState) {
    !newsState.contentType && (newsState.contentType = ContentType.NONE)
    dispatch({ curState, newsState, type: APPEND, page: param.page })
  }
}

const getNewsFromHistoryState = (): NewsListState => {
  if (history.location && history.location.state && history.location.state[HistoryStateKey.NEWS_LIST_STATE]) {
    const newsList = {
      ...history.location.state[HistoryStateKey.NEWS_LIST_STATE],
    }
    history.location.state = {
      ...history.location.state,
      [HistoryStateKey.NEWS_LIST_STATE]: null,
    }
    return newsList
  }
}

export default (state: NewsListState = initialState, action) => {
  switch (action.type) {
    case INIT:
    case RESTORE:
      return {
        page: action.page,
        newsState: action.newsState,
      }
    case APPEND:
      return {
        page: action.page,
        newsState: { ...action.newsState, articles: [...state.newsState.articles, ...action.newsState.articles] },
      }
    default:
      return state
  }
}
